<template>
  <svg width="6" height="6" viewBox="0 0 6 6">
    <g transform="rotate(180,3,3)" stroke="#3498db" stroke-linejoin="round">
      <circle cx="3" cy="3" r="2.5" fill="#fff"/>
      <path d="m2.992 5.3677a2.3677 2.3677 0 0 1-2.3597-2.3718 2.3677 2.3677 0 0 1 2.3677-2.3637" fill="#3498db" stroke-width=".26458"/>
    </g>
  </svg>
</template>
